import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, Signal, TemplateRef, ViewContainerRef, booleanAttribute, computed, signal } from '@angular/core';
import { PageComponent } from '../page/page.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { PaginatorComponent } from 'src/app/shared/components/paginator/paginator.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SidenavComponent } from '../../sidenav/sidenav.component';
import { SidenavService, SidenavSizeType } from 'src/app/core/services/sidenav.service';
import { TemplatePortal } from '@angular/cdk/portal';
import { TableComponent } from 'src/app/shared/components/table/table.component';
import { ISearchEvent, ITableColumn } from 'src/app/core/models/table.model';
import { IPageEvent } from 'src/app/core/models/paginator.model';
import { QueryService } from 'src/app/core/services/query.service';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { Observable, debounceTime, distinctUntilChanged } from 'rxjs';
import { ISortEvent } from 'src/app/core/models/sort.model';
import { IFilterEvent } from 'src/app/core/models/filters.model';
import { CrudService } from 'src/app/core/services/crud.service';
import { Router } from '@angular/router';
import { isNotEmpty } from 'src/app/shared/functions/utils.functions';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import { QuerySentrynelService } from 'src/app/core/services/query-sentrynel.service';
import { PaginatorSentrynelComponent } from 'src/app/shared/components/paginator-sentrynel/paginator-sentrynel.component';
import { TableSelectComponent } from "../../../shared/components/table-select/table-select.component";
import { DialogService } from 'src/app/core/services/dialog.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MyDialogPuntiCampionamentoComponent } from 'src/app/modules/punti-campionamento/my-dialog-scaduti/my-dialog-punti-campionamento.component';
import { CrudWszService } from 'src/app/core/services/crud-wsz.service';
import { QueryWszService } from 'src/app/core/services/query-wsz.service';

@Component({
  selector: 'app-page-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    InputTextComponent,
    MyButtonComponent,
    PageComponent,
    PaginatorComponent,
    PaginatorSentrynelComponent,
    SidenavComponent,
    TableComponent,
    TableSelectComponent,
    MatDialogModule,
    MyDialogPuntiCampionamentoComponent
],
  templateUrl: './page-list.component.html',
  styleUrl: './page-list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageListComponent<TData = any> implements OnInit {
  checkQueryServiceSentrynel:boolean=false
  @Input() data?: Signal<TData[]>;
  @Input() columns: ITableColumn[] = [];
  @Input() placeholderSearch:string = "Cerca..."
  @Input() customClickFunction: Function=()=>null;
  @Input() showButtonExportExcel:boolean=false
  @Input() isRowClickable: boolean=true;
  @Input() costumEditFunction:boolean=false
  @Input() canImportExcel:boolean=true
  @Input() visibleColumns: Signal<string[]> = signal(this.columns.map((column: ITableColumn) => column.name));
  @Input({ transform: booleanAttribute }) canInsert: boolean = true;
  @Input() onInsertFunction?: (args?: any) => Observable<any>;
  @Input() editFunction: Function=()=>null;
  @Input({ transform: booleanAttribute }) canSearch: boolean = true;
  @Input({ transform: booleanAttribute }) canFilter: boolean = true;
  @Input({ transform: booleanAttribute }) canShowDetail: boolean = true;
  @Input() insertForm?: FormGroup;
  @Input() modifyForm?: FormGroup;
  @Input() insertFormTitle: string = '';
  @Input() insertFormSize: SidenavSizeType = 'normal';
  @Input() filterForm?: FormGroup;
  @Input() queryService!: QueryService<TData> | QuerySentrynelService<TData> | QueryWszService<TData>;
  @Input() crud?: CrudService<TData> | CrudSentrynelService<TData> | CrudWszService<TData>;
  @Input() canShowBreadcrumb?:boolean;
  @Input() excelBtnTitle!: string;
  @Input() canExport: boolean = false;
  @Input() canImport: boolean = false;
  @Input({ transform: booleanAttribute }) canUpdate: boolean = false;
  @Input() isSelectableTable:boolean=false;
  @Output() page: EventEmitter<IPageEvent> = new EventEmitter<IPageEvent>();
  @Output() sort: EventEmitter<ISortEvent> = new EventEmitter<ISortEvent>();
  @Output() search: EventEmitter<ISearchEvent> = new EventEmitter<ISearchEvent>();
  @Output() filters: EventEmitter<IFilterEvent> = new EventEmitter<IFilterEvent>();
  @Output() insert: EventEmitter<TData> = new EventEmitter<TData>();
  @Output() modelChange = new EventEmitter<TData>();
  @Output() myIdEditEventt = new EventEmitter();
  @Input() notCheckFilter=new Array()
  listPageForm: FormGroup;
  filtersApplied = computed(() => this.notCheckFilter.length>0 ? 
  Object.keys(this.queryService?.filters() ?? {}).filter(objKey=>this.notCheckFilter.indexOf(objKey)==-1).length :
  Object.keys(this.queryService?.filters() ?? {}).length);

  isFiltersApplied = computed(() => this.filtersApplied() > 0);

  hasCrud = computed(() => {
    return this.crud !== undefined
  });

  constructor (
    private readonly fb: FormBuilder,
    public sidenavService: SidenavService,
    private vcf: ViewContainerRef,
    private router: Router,
    private dialogService: DialogService,
    public myDialog: MatDialog
  ) {
    this.listPageForm = this.fb.group({
      search: this.fb.control('', []),
      filter: this.filterForm
    })
  }

  ngOnInit(): void {
    if(isNotEmpty(this.queryService?.search())){
      this.listPageForm.get('search')?.setValue(this.queryService?.search())
      this.listPageForm.get('search')?.markAsDirty();
    }
    this.listPageForm.get('search')?.valueChanges.pipe(
      debounceTime(300), // Aggiungi un ritardo prima di applicare il filtro
      distinctUntilChanged() // Filtra solo se il valore cambia rispetto al precedente
    ).subscribe((value) => {
      this.handleSearch({ value: value });
    })

    this.getList();
  }

  get list() {
    return this.data ?? this.queryService?.list;
  }

  get pageable() {
    return this.queryService?.pageable;
  }

  get sortState() {
    return this.queryService?.sort();
  }

  get hasFilter() {
    return this.filterForm !== undefined;
  }

  onInsertClick(templateRef: TemplateRef<any>) {
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal, 'end', this.insertFormSize);
    if (this.onInsertFunction) {
      this.onInsertFunction();
    }
  }
  onEditClick(templateRef: TemplateRef<any>) {
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal, 'end');
    if (this.onInsertFunction) {
      this.onInsertFunction();
    }
  }
  onSaveClick() {
    if (this.insertForm?.valid) {
      if(this.costumEditFunction){
        this.editFunction(this.crud);
        this.sidenavService.clearContents();
        this.getList()
      }else{
        this.crud?.save(this.insertForm?.value).subscribe({
          next: (modelValue) => {
            this.sidenavService.clearContents();
            this.insert.emit(modelValue);
            if (this.onInsertFunction) {
              this.onInsertFunction(modelValue)
            } else {
              setTimeout(() => {
                this.getList();
              }, 0);
            }
          }
        });
      }

    }
  }

  onFilterClick(templateRef: TemplateRef<any>) {
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal);
  }

  onApplyFilterClick() {
    let filters: IFilterEvent = {};
    for (const key in this.filterForm?.value.filters) {
      if (this.filterForm?.value.filters.hasOwnProperty(key) && isNotEmpty(this.filterForm?.value.filters[key])) {
        filters[key] = this.filterForm?.value.filters[key];
      }
    }
    this.handleFilters(filters);
    this.sidenavService.clearContents();
  }

  onResetFilterClick() {
    this.filterForm?.reset();
    if(this.notCheckFilter.length>0){
      let filters: IFilterEvent = {};
      for (const key in this.filterForm?.value.filters) {
        if (this.filterForm?.value.filters.hasOwnProperty(key) && isNotEmpty(this.filterForm?.value.filters[key])) {
          filters[key] = this.filterForm?.value.filters[key];
        }
      }
      this.handleFilters(filters);
    }else{
      this.handleFilters({});
    }

    this.sidenavService.clearContents();
  }

  handlePageEvent(event: IPageEvent) {
    this.queryService?.onPage(event);
    this.page.emit(event);
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  handleSortEvent(event: ISortEvent) {
    this.queryService?.onSort(event);
    this.sort.emit(event);
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  handleSearch(event: ISearchEvent) {
    this.queryService?.onSearch(event);
    this.search.emit(event);
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  handleFilters(event: IFilterEvent) {
    this.queryService?.onFilter(event);
    this.filters.emit(event);
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  getList() {
    console.log(this.queryService)
    if (this.queryService instanceof QuerySentrynelService) {
      this.checkQueryServiceSentrynel=true
      this.queryService?.get({ meta: this.queryService?.pageable(), sort: this.queryService?.sort(), search: this.queryService?.search(), filters: this.queryService.filters() });
    }else{
 
      this.queryService?.get({ pageable: this.queryService?.pageable(), sort: this.queryService?.sort(), search: this.queryService?.search(), filters: this.queryService.filters() });
    }

  }
  esportaExcel(){
    this.modelChange.emit();
  }

  showDialogImportaExcel(): void {
    const dialogRef = this.myDialog.open(MyDialogPuntiCampionamentoComponent, {
      width: '600px',
      height: '400px'
    })

    dialogRef.afterClosed().subscribe(() => {
      
    })
  }
  
  onRowClick(row: any) {
    if(this.isRowClickable){
      const primaryKey = this.getPrimaryKey();
      if (primaryKey) {
        this.isStringList(row[primaryKey.field].toString())
        ? this.navigateToDetail(row[primaryKey.field].toString()) 
        : this.navigateToDetail(encodeURIComponent(row[primaryKey.field].toString()))
  
      }
    }else{
        this.customClickFunction(row)
    }

  }
  isStringList(lista: string){
    if(lista.indexOf(',')==-1){
      return true
    }
    else{
      return false 
    }
  }
  get hasPrimaryKey() {
    return this.getPrimaryKey() !== undefined;
  }

  private navigateToDetail(id: string) {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    urlSegments.pop();
    urlSegments.push(id.toString());
    const newUrl = urlSegments.join('/');
    this.router.navigate([newUrl]);
  }

  private getPrimaryKey() {
    return this.columns.find(column => column.primaryKey && column.primaryKey === true);
  }
  selectedIdCheckBox(event:any){
    this.myIdEditEventt.emit(event)
  }
}

